import * as React from 'react';
import {useSelector} from 'react-redux';
import useI18n from 'src/hooks/useI18n';

import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {
  Panel,
  PanelBody,
  PanelHeader,
} from '@spaced-out/ui-design-system/lib/components/Panel';
import {SubTitleLarge} from '@spaced-out/ui-design-system/lib/components/Text';
import {Badge} from '@spaced-out/ui-design-system/lib/components/Badge';
import {CrmParsing} from 'src/components/crm/parsing/parsing';
import {Tooltip} from '@spaced-out/ui-design-system/lib/components/Tooltip';
import {useUntriedCountPolling} from 'src/hooks/useUntriedCountPolling';

import css from 'src/components/navigation/top.css';


export const ResumeParsing = () => {
  const [showParsingPanel, setShowParsingPanel] = React.useState(false);
  const {isPolling, untriedCount} = useUntriedCountPolling();

  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  return (
    <div className={css.badgeContainer}>
      <Tooltip
        title={t('Resume_Parsing', 'Resume Parsing')}
        delayMotionDuration="slowest"
        placement="bottom-end"
      >
        <Button
          iconLeftName="hourglass"
          onClick={() => setShowParsingPanel(true)}
          size="small"
          type="ghost"
          iconLeftType="solid"
          ariaLabel={t('Resume_Parsing', 'Resume Parsing')}
        />
      </Tooltip>
      {untriedCount > 0 ? (
        <Badge
          fill={'blue'}
          text={`${untriedCount}`}
          classNames={{wrapper: css.messageCountBadge}}
        />
      ) : null}
      <Panel
        anchor="right"
        initialFocus={2}
        onClose={() => setShowParsingPanel(false)}
        size="medium"
        tapOutsideToClose
        isOpen={showParsingPanel}
      >
        <PanelHeader
          onCloseButtonClick={() => setShowParsingPanel(false)}
          size="medium"
        >
          <SubTitleLarge>
            {t('Resume_Parsing_Queue', 'Resume Parsing Queue')}
            {untriedCount > 0 ? `(${untriedCount})` : null}
          </SubTitleLarge>
        </PanelHeader>
        <PanelBody className={css.panelPaddingNull}>
          <CrmParsing showParsingPanel={showParsingPanel} />
        </PanelBody>
      </Panel>
    </div>
  );
};
